export default "__VITE_ASSET__C$Ml$d2h__"